// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"506":"c57e7088","719":"37aa3f8f","730":"e463f741","752":"ce739bda","787":"6e210832"}[chunkId] + ".chunk.js";
};